import { API_ENDPOINTS } from '../constants/apiEndpoints';
import { postJSON } from '../utils/RequestUtils';

export const AITranslationStatus = {
  PUBLISHED: 'Published',
  NEEDS_REVIEW: 'NeedsReview',
  DEACTIVATED: 'Deactivated',
  NEW: 'New',
} as const;

export type GetAITranslationRequest = {
  stringToTranslate: string;
  language: string;
};

export type GetAITranslationResponse = {
  originalString: string;
  translatedString: string;
  language: string;
  status: string | null;
  translationRecordId: string | null;
};

export async function getAITranslation(
  payload: GetAITranslationRequest
): Promise<GetAITranslationResponse> {
  if (!payload?.stringToTranslate?.trim()) {
    throw new Error('Text to translate cannot be empty');
  }
  if (!payload?.language?.trim()) {
    throw new Error('Target language is required');
  }

  return postJSON<GetAITranslationResponse, GetAITranslationRequest>(
    API_ENDPOINTS.GENERATE_AI_TRANSLATION,
    payload
  );
}

export type ReactivateTranslationRequest = {
  originalText: string;
  language: string;
};

export type ReactivateTranslationResponse = {
  status: string;
  message: string;
  translationRecordId: string;
};

export async function reactivateTranslation(
  payload: ReactivateTranslationRequest
): Promise<ReactivateTranslationResponse> {
  if (!payload?.originalText?.trim()) {
    throw new Error('Original text cannot be empty');
  }
  if (!payload?.language?.trim()) {
    throw new Error('Target language is required');
  }
  return postJSON<ReactivateTranslationResponse, ReactivateTranslationRequest>(
    API_ENDPOINTS.REACTIVATE_TRANSLATION,
    payload
  );
}
